module.exports = __webpack_public_path__ + "img/progress2.10b1d49a.png";